import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { makeStyles } from '@material-ui/core/styles';

import styled from 'styled-components';

import { displayInAppError } from '../../../utils/toast/Toast';

import {
  closeDrawer,
  getCommandsForMerge,
  mergeCommands
} from '../mergeCommandsActions';

import MergeCommandsOptionDialog from './MergeCommandsOptionDialog';
import MergeConfirmationDialog from './MergeConfirmationDialog';
import DeliveryInformationsCard from './DeliveryInformationsCard';

const TitleHelper = styled.h6`
  font-weight: 400;
  font-size: 1rem;
`;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3)
  },
  drawerPaper: {
    borderRadius: '15px 0px 0px 0px',
    width: '41vw',
    overflowX: 'hidden'
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 500,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.07)'
    }
  }
}));

const canBeMerge = currentValue =>
  currentValue.state === 'draft' || currentValue.state === 'picking_required';

const everyStateIsDraft = currentValue => currentValue.state === 'draft';
const everyStateIsPickingRequired = currentValue =>
  currentValue.state === 'picking_required';

const MergeCommandsDrawer = ({
  isOpen,
  dispatchCloseDrawer,
  dispatchGetCommandsForMerge,
  dispatchMergeCommand,
  checkedCommandsIds,
  commandsForMerge
}) => {
  useEffect(() => {
    if (isOpen === true) {
      dispatchGetCommandsForMerge(checkedCommandsIds);
    }
  }, [isOpen, dispatchGetCommandsForMerge, checkedCommandsIds]);

  const [openDialogOptions, setOpenDialogOptions] = useState(false);
  const [openDialogConfirmation, setOpenDialogConfirmation] = useState(false);
  const [
    selectedCommandInformations,
    setSelectedCommandInformations
  ] = useState();

  function handleOpenDialogOptions() {
    setOpenDialogOptions(true);
  }

  function handleCloseDialogOptions() {
    setOpenDialogOptions(false);
  }

  function handleOpenDialogConfirmation() {
    setOpenDialogConfirmation(true);
  }

  function handleCloseDialogConfirmation() {
    setOpenDialogConfirmation(false);
  }

  const handleMergeCommand = (
    readyToBePickedUp,
    commands = selectedCommandInformations
  ) => {
    const mergeCommandsInformations = {
      commandsIds: checkedCommandsIds,
      offerCode: commands.offer.code,
      type: commands.type.code,
      deliveryType: commands.deliveryType,
      readyToBePickedUp,
      recipient: {
        email: commands.recipientEmail,
        phoneNumber: commands.recipientPhoneNumber,
        firstname: commands.recipientFirstname,
        lastname: commands.recipientLastname,
        companyName: commands.recipientCompanyName
      },
      recipientAddress: {
        street: commands.recipientAddress.street,
        street2: commands.recipientAddress.street2,
        city: commands.recipientAddress.city,
        postalCode: commands.recipientAddress.postalCode,
        countryCode: commands.recipientAddress.countryCode
      }
    };
    dispatchMergeCommand(mergeCommandsInformations);
  };

  const handleClick = () => {
    handleCloseDialogConfirmation();
    if (commandsForMerge.every(canBeMerge)) {
      if (
        commandsForMerge.every(everyStateIsPickingRequired) ||
        commandsForMerge.every(everyStateIsDraft)
      ) {
        handleMergeCommand(
          commandsForMerge.every(everyStateIsPickingRequired),
          selectedCommandInformations
        );
      } else {
        handleOpenDialogOptions();
      }
    } else {
      displayInAppError(
        "Vous pouvez fusionner uniquement des commandes dans le statut ' Traitement demandé '  ou ' En attente d'instruction '"
      );
    }
  };
  const classes = useStyles();
  return (
    <SwipeableDrawer
      classes={{
        paper: classes.drawerPaper
      }}
      anchor="right"
      onOpen={() => null}
      onClose={() => {
        dispatchCloseDrawer();
      }}
      open={isOpen}
    >
      <MergeCommandsOptionDialog
        handleClose={handleCloseDialogOptions}
        open={openDialogOptions}
        handleMergeCommand={handleMergeCommand}
      />
      <MergeConfirmationDialog
        handleClose={handleCloseDialogConfirmation}
        handleClickMerge={handleClick}
        open={openDialogConfirmation}
        numberOfCommandsToMerge={checkedCommandsIds.length}
        selectedCommandInformations={selectedCommandInformations}
      />
      <div style={{ padding: 20 }}>
        <h1>Fusion de commande</h1>
        <TitleHelper>
          Sélectionner les informations à appliquer pour toutes les commandes à
          fusionner
        </TitleHelper>
        {commandsForMerge.map(command => (
          <div className={classes.root} key={command.id}>
            <DeliveryInformationsCard
              command={command}
              setSelectedCommandInformations={setSelectedCommandInformations}
              handleOpenDialogConfirmation={handleOpenDialogConfirmation}
              isActionCard
            />
          </div>
        ))}
      </div>
    </SwipeableDrawer>
  );
};

const mapStateToProps = state => ({
  checkedCommandsIds: state.commands.checkedCommandsIds,
  isOpen: state.mergeCommands.openDrawer,
  commandsForMerge: state.mergeCommands.commandsForMerge
});

const mapDispatchToProps = dispatch => ({
  dispatchCloseDrawer: () => dispatch(closeDrawer()),
  dispatchGetCommandsForMerge: commandsId =>
    dispatch(getCommandsForMerge(commandsId)),
  dispatchMergeCommand: commandsId => dispatch(mergeCommands(commandsId))
});

MergeCommandsDrawer.propTypes = {
  dispatchCloseDrawer: PropTypes.func.isRequired,
  dispatchMergeCommand: PropTypes.func.isRequired,
  dispatchGetCommandsForMerge: PropTypes.func.isRequired,
  checkedCommandsIds: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  commandsForMerge: PropTypes.array.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MergeCommandsDrawer);
